export default __webpack_public_path__ + "static/international-metric-mobile-1aeb232530d0e5d7c8c6d21c8c0fd23a.svg";